import React from "react";

import config from "config";
import helper from "actions/helper";
import request from "actions/request";
import xlsx from "actions/xlsx";
import print from "actions/print";

export default class Main extends React.Component {
    _config = config;
    _helper = helper;
    _request = request;
    _xlsx = xlsx;
    _print = print;

    componentDidMount() {
        if (this.useTooltip)
            this._checkSetTooltip();
    }

    componentDidUpdate() {
        if (this.useTooltip)
            this._checkSetTooltip();
    }

    _checkSetTooltip() {
        clearTimeout(globalThis.tooltipCheckTimer);
        globalThis.tooltipCheckTimer = setTimeout(() => {
            clearTimeout(globalThis.tooltipCheckTimer);
            this.setTooltips();
        }, 250);
    }

    /*setTooltips() {
        document.body.querySelectorAll("[data-tooltip]").forEach(node => {
            if (node.vTooltipSet)
                return;

            node.vTooltipSet = true;
            node.vTooltipText = node.dataset.tooltip ? this.tr(node.dataset.tooltip) : "";

            this._helper.on(node, "mouseenter", this._helper.showTooltip.bind(this._helper, node));
            this._helper.on(node, "mouseleave", this._helper.hideTooltip.bind(this._helper));
            this._helper.on(node, "click", this._helper.hideTooltip.bind(this._helper));
        });
    }*/
    setTooltips() {
        document.body.querySelectorAll("[data-tooltip]").forEach(node => {
            // Если не было инициализации — инициализируем (навешиваем обработчики).
            if (!node.vTooltipSet) {
                node.vTooltipSet = true;
                this._helper.on(node, "mouseenter", this._helper.showTooltip.bind(this._helper, node));
                this._helper.on(node, "mouseleave", this._helper.hideTooltip.bind(this._helper));
                this._helper.on(node, "click", this._helper.hideTooltip.bind(this._helper));
            }
            // Проверяем, поменялось ли значение data-tooltip
            const newText = node.dataset.tooltip ? this.tr(node.dataset.tooltip) : "";
            if (node.vTooltipText !== newText) {
                node.vTooltipText = newText;
            }
        });
    }

    tr() {
        return this._helper.tr.apply(this._helper, arguments);
    }

    changeState(key, value, cb) {
        const fn = cb?.apply ? cb : Function;

        this.setState({ [key]: value }, fn);
    }

    toggleState(key) {
        this.changeState(key, !this.state[key]);
    }

    async printShow(name, params) {
        this._helper.showLoading();
        const url = await this._request.jasperReports.getPdf(name, params);
        this._helper.hideLoading();

        if (url)
            this._helper.showPrintBox(url);
    }

}
